import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBadge from "components/MDBadge";

import DataTable from "examples/Tables/DataTable";

import MDActionConfigurator from "components/MDActionConfigurator";

import {
  createNewComplaintRequirement,
  complaintRequirementUpdating,
} from "actions/complaintRequirementActions";
import { getProfile } from "actions/userActions";

function ComplaintRequirementsSection({ productSingle }) {
  const configuratorRef = useRef(null);
  const dispatch = useDispatch();
  const [currentState, setCurrentState] = useState("");
  const [currentData, setCurrentData] = useState({
    _id: "",
    complaintRequirementTitle: "",
    description: "",
    complaintRequirementType: "",
    product: productSingle?._id,
    supplier: productSingle?.supplier,
    optional: false,
    active: true,
  });

  const getMe = useSelector((state) => state.getMe);
  const { me } = getMe;

  useEffect(() => {
    // if (me?.length === 0) {
    dispatch(getProfile());
    // }
  }, [dispatch]);

  const handleToggleBackdrop = (item, state) => {
    setCurrentData(item);
    setCurrentState(state);
    if (configuratorRef.current) {
      configuratorRef.current.handleToggleConfigurator();
    }
  };

  const requirementOptions = [
    {
      name: "Text",
      value: "text",
    },
    {
      name: "Number",
      value: "number",
    },
    {
      name: "Image",
      value: "image",
    },
    {
      name: "File",
      value: "file",
    },
    {
      name: "Link",
      value: "link",
    },
  ];

  const handleSubmitComplaintRequirement = (e) => {
    if (currentState === "edit") {
      dispatch(complaintRequirementUpdating(currentData?._id, e));
    } else {
      dispatch(createNewComplaintRequirement(e));
    }
    handleToggleBackdrop({}, "");
  };

  function renderRequirementsRows(data) {
    const values = [];
    data?.forEach((item, index) => {
      const newElement = {
        title: (
          <MDBox maxWidth={150}>
            <MDTypography
              key={index}
              variant="caption"
              color="text"
              fontWeight="medium"
            >
              {item?.complaintRequirementTitle}
            </MDTypography>
          </MDBox>
        ),
        description: (
          <MDBox maxWidth={200}>
            <MDTypography variant="caption" color="text" fontWeight="medium">
              {item?.description}
            </MDTypography>
          </MDBox>
        ),
        type: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {item?.complaintRequirementType}
          </MDTypography>
        ),
        optional: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {item?.optional ? (
              <MDBox ml={-1}>
                <MDBadge
                  badgeContent="Optional"
                  color="success"
                  variant="gradient"
                  size="sm"
                />
              </MDBox>
            ) : (
              <MDBox ml={-1}>
                <MDBadge
                  badgeContent="Not Optional"
                  color="dark"
                  variant="gradient"
                  size="sm"
                />
              </MDBox>
            )}
          </MDTypography>
        ),
        active: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {item?.active ? (
              <MDBox ml={-1}>
                <MDBadge
                  badgeContent="active"
                  color="dark"
                  variant="gradient"
                  size="sm"
                />
              </MDBox>
            ) : (
              <MDBox ml={-1}>
                <MDBadge
                  badgeContent="inactive"
                  color="success"
                  variant="gradient"
                  size="sm"
                />
              </MDBox>
            )}
          </MDTypography>
        ),
        action: (
          <>
            {(me?.role === "super_admin" || me?.role === "admin") && (
              <MDTypography
                component="a"
                href="#"
                variant="caption"
                color="text"
                fontWeight="medium"
                onClick={() => handleToggleBackdrop(item, "edit")}
              >
                Edit
              </MDTypography>
            )}
          </>
        ),
      };
      values.push(newElement);
    });
    return values;
  }

  return (
    <MDBox>
      <MDBox>
        <MDTypography variant="h6">Complaint Requirements</MDTypography>
      </MDBox>
      <MDBox p={2} mt="auto">
        {(me?.role === "super_admin" || me?.role === "admin") && (
          <MDButton
            component="a"
            href="#"
            rel="noreferrer"
            variant="gradient"
            color="info"
            onClick={() =>
              handleToggleBackdrop(
                {
                  _id: "",
                  complaintRequirementTitle: "",
                  description: "",
                  complaintRequirementType: "",
                  product: productSingle?._id,
                  supplier: productSingle?.supplier,
                  optional: false,
                  active: true,
                },
                ""
              )
            }
          >
            <Icon sx={{ fontWeight: "bold" }}>add</Icon>
            &nbsp;New Complaint Requirements{" "}
            {productSingle?.productNumber &&
              ` for ${productSingle?.productName} - ${productSingle?.productNumber}`}
          </MDButton>
        )}
      </MDBox>
      <MDBox p={3} mb={5}>
        <DataTable
          table={{
            columns: [
              {
                Header: "Requirement Title",
                accessor: "title",
                width: "20%",
                align: "left",
              },
              {
                Header: "Requirement Description",
                accessor: "description",
                width: "30%",
                align: "left",
              },
              {
                Header: "Data Type",
                accessor: "type",
                width: "10%",
                align: "center",
              },
              {
                Header: "Optional",
                accessor: "optional",
                width: "10%",
                align: "center",
              },
              {
                Header: "Active",
                accessor: "active",
                width: "10%",
                align: "center",
              },
              {
                Header: "action",
                accessor: "action",
                width: "10%",
                align: "center",
              },
            ],

            rows: renderRequirementsRows(productSingle?.complaintRequirements),
          }}
          isSorted={false}
          entriesPerPage={false}
          showTotalEntries={false}
          noEndBorder
        />
      </MDBox>

      <MDActionConfigurator
        ref={configuratorRef}
        title={`${productSingle?.productName} - ${productSingle?.productNumber}'s Complaint Requirement Config`}
        onCompleteConfig={handleSubmitComplaintRequirement}
        data={[
          {
            keyType: "_id",
            valueType: currentData?._id,
          },
          {
            labelType: "Selected Product",
            placeholderType: "Selected Product",
            dataType: "disabled",
            keyType: "product",
            valueType: productSingle?._id,
          },
          {
            labelType: "Selected Supplier",
            placeholderType: "Selected Supplier",
            dataType: "disabled",
            keyType: "supplier",
            valueType: productSingle?.supplier?._id,
          },
          {
            labelType: "Complaint Requirement Title",
            placeholderType: "Enter Complaint Requirement Title",
            dataType: "text",
            keyType: "complaintRequirementTitle",
            valueType: currentData?.complaintRequirementTitle,
          },
          {
            labelType: "Description",
            placeholderType: "Enter Description",
            dataType: "text",
            keyType: "description",
            valueType: currentData?.description,
          },
          {
            labelType: "Complaint Requirement Type",
            placeholderType: "Enter Complaint Requirement Type",
            dataType: "select",
            keyType: "complaintRequirementType",
            valueType: currentData?.complaintRequirementType,
            options: requirementOptions,
          },
          {
            labelType: "Optional",
            placeholderType: "Optional",
            dataType: "active",
            keyType: "optional",
            valueType: currentData?.optional,
          },
          {
            labelType: "Active",
            placeholderType: "Active",
            dataType: "active",
            keyType: "active",
            valueType: currentData?.active,
          },
        ]}
        state={currentState}
      />
    </MDBox>
  );
}

export default ComplaintRequirementsSection;
